import { Injectable } from '@angular/core';
import { List } from '@app/core/interfaces/list';
import { CategoriesService } from '@app/entities/categories/services/categories.service';
import { CountriesService } from '@app/entities/countries/services/countries.service';
import { ImmutableContext } from '@ngxs-labs/immer-adapter';
import { Action, State, StateContext } from '@ngxs/store';
import { tap } from 'rxjs/operators';
import { ListingsStateModel } from './listings-state.model';
import { LoadCategoriesList, LoadCountriesList } from './listings.actions';
import { Country } from '@app/entities/countries/interfaces/country';

@State<ListingsStateModel>({
  name: 'listings',
})
@Injectable()
export class ListingsState {
  constructor(
    private categoriesService: CategoriesService,
    private countriesService: CountriesService,
  ) {}

  @Action(LoadCategoriesList)
  @ImmutableContext()
  loadCategoriesList({ getState, setState }: StateContext<ListingsStateModel>) {
    if (getState().categories) {
      return;
    }

    return this.categoriesService.getList().pipe(
      tap((categories: List) => {
        return setState((state: ListingsStateModel) => {
          state.categories = categories;

          return state;
        });
      }),
    );
  }

  @Action(LoadCountriesList)
  @ImmutableContext()
  loadCountriesList({ getState, setState }: StateContext<ListingsStateModel>) {
    if (getState().countries) {
      return;
    }

    return this.countriesService.getList().pipe(
      tap((countries: Country[]) => {
        return setState((state: ListingsStateModel) => {
          state.countries = countries;

          return state;
        });
      }),
    );
  }
}
